import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["options", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSelector } from 'reselect';
import { appendPath, getValue, parentPath, pathComparator } from '@truqc/content-path';
import { clone } from 'ramda';
import { getContent, getStaticContent, getPropOptions } from './simpleSelectors';
import newPathSelector from './newPathSelector';
const getFormatOptions = (state, props) => (props.format || {}).options;
const getFormatOptionsContentPath = (state, props) => (props.format || {}).optionsContentPath;
const isLeafNode = node => !Object.values(node).some(child => typeof child === 'object');
const getSortAscending = (state, props) => (props.format || {}).sortAscending;
const sortCollectionContent = options => options.sort(pathComparator('_created'));
const _transform = function transform() {
  let tree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  Object.keys(tree).forEach(key => {
    const value = tree[key];
    if (typeof value === 'object' && value !== null && value !== undefined) {
      if (isLeafNode(value)) {
        // This preserves the identifier from the original option during transformation
        value.identifier = key;
      }
      _transform(value, key);
    }
    if (key === 'children') {
      const options = Object.keys(tree[key]).map(childKey => tree[key][childKey]);
      /* eslint-disable no-param-reassign */
      tree.options = options;
      tree.identifier = parent;
      delete tree[key];
      /* eslint-enable no-param-reassign */
    }
  });
};
const _handleCollectionFormat = function handleCollectionFormat(tree) {
  let newTree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  Object.keys(tree).forEach(key => {
    const _tree$key = tree[key],
      options = _tree$key.options,
      children = _tree$key.children,
      value = _objectWithoutProperties(_tree$key, _excluded);
    value.identifier = value.identifier || key;
    if (options || children) {
      const optionChildren = _handleCollectionFormat(options || children);
      value.options = optionChildren;
    }
    newTree.push(value);
  });
  return sortCollectionContent(newTree);
};

/* eslint-disable-next-line default-param-last */
const unboundSortOptions = function unboundSortOptions() {
  let sortAscending = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let options = arguments.length > 1 ? arguments[1] : undefined;
  if (!sortAscending) {
    return options.reverse();
  }
  return options;
};
export default createSelector([getContent, getStaticContent, newPathSelector, getFormatOptions, getFormatOptionsContentPath, getPropOptions, getSortAscending], (content, staticContent, path, options, optionsContentPath, propOptions, sortAscending) => {
  const sortOptions = unboundSortOptions.bind(this, sortAscending);
  if (propOptions && propOptions.length) return sortOptions(propOptions);
  if (!options && !optionsContentPath) return [];
  if (options) {
    return Array.isArray(options) ? sortOptions(options) : sortOptions(_handleCollectionFormat(options));
  }
  // Use parent path when looking up identifier path to properly parse siblings
  const parent = parentPath(path);
  const optionsPath = appendPath(parent, optionsContentPath);
  let result = getValue(optionsPath, content);
  if (result === undefined) {
    result = getValue(optionsPath, staticContent);
  }
  if (!result) {
    return [];
  }
  let transformedTree = result;
  if (JSON.stringify(transformedTree).includes('children')) {
    // Need to transform to an options structure
    transformedTree = clone(transformedTree);
    _transform(transformedTree);
  }
  // Options must be objects, with at least an identifier
  const finalValues = sortCollectionContent(Object.keys(transformedTree).filter(id => Object.keys(transformedTree[id]).length > 0).map(id => {
    const value = transformedTree[id];
    return _objectSpread(_objectSpread({}, value), {}, {
      identifier: value.identifier || id
    });
  }));
  return sortOptions(finalValues);
});